// extracted by mini-css-extract-plugin
export default {"root":"PositivityGenerator_root__Sdsil"};